import * as React from 'react';
import EmbeddedPowerBIReport from '../../../../../components/Reporting';
import { ReportingTabProps } from '../../../../../types/reporting.type';

const AverageRateReport: React.FunctionComponent<ReportingTabProps> = (props) => {
    const { reportName } = props;
    const RENEWAL_REPORT_ID = 'c55ebdba-be39-45c6-9268-b6c4a94cb53e';
    const RENEWAL_WORKSPACE_ID = '5969b83e-5d39-4154-ad43-a016b71cd9e0';

    return (
        <>
            <EmbeddedPowerBIReport
                reportId={RENEWAL_REPORT_ID}
                workspaceId={RENEWAL_WORKSPACE_ID}
                reportName={reportName}
                hideFilters
                waitForPrimary
            />
        </>
    );
};

export default AverageRateReport;
